import { WEBCHAT_SOURCE } from 'modules/webchat/domain/constants';
import { IMountWebchatDTO } from 'modules/webchat/domain/dtos';
import { TWebchatExtraParams } from 'modules/webchat/domain/entities';
import { IWebchatWidgetProvider } from 'modules/webchat/domain/providers';
import {
  IWebchatChatSessionsRepository,
  IWebchatTokensRepository,
} from 'modules/webchat/domain/repositories';

export default class MountWebchatUseCase {
  constructor(
    private widgetProvider: IWebchatWidgetProvider,
    private chatSessionsRepository: IWebchatChatSessionsRepository,
    private tokensRepository: IWebchatTokensRepository,
  ) {}

  public execute({ settings, identity, language }: IMountWebchatDTO): void {
    const extraParams: TWebchatExtraParams = {
      identifier: identity.identifier,
      origem: WEBCHAT_SOURCE,
      idioma: language,
    };

    if (identity.customerId) {
      extraParams.idcliente = String(identity.customerId);
    }

    if (identity.name) extraParams.nome = identity.name;
    if (identity.phone) extraParams.telefone = identity.phone;
    if (identity.type) extraParams.tipo = identity.type;

    this.widgetProvider.mount(settings, extraParams, {
      issueToken: this.buildTokenIssuer(settings.uuid, identity),
    });
  }

  /**
   * Cliente logado: a sala vem da sessão dele no BFF, a mesma em qualquer
   * aparelho. Visitante: uma sala por identifier, guardada neste navegador,
   * para o login trocar de conversa e sair do chat esquecer a sala.
   */
  private buildTokenIssuer(
    channelUuid: string,
    identity: IMountWebchatDTO['identity'],
  ) {
    if (identity.customerId) {
      return () => this.tokensRepository.issueForCustomer({ channelUuid });
    }

    const sessionId = this.chatSessionsRepository.findOrCreate(
      identity.identifier,
    );

    return () => this.tokensRepository.issue({ channelUuid, sessionId });
  }
}
